import UploadFileIcon from '@mui/icons-material/UploadFile';
import React, { useCallback, useState } from 'react';

import { cn } from '@/utils/cn';

import LightTooltip from './LightTooltip';

interface FileUploadComponentProps {
	onFilesSelected: (files: FileList | null) => void;
	rowId: string;
	disabled?: boolean;
}

const FileUploadComponent: React.FC<FileUploadComponentProps> = ({
	onFilesSelected,
	rowId,
	disabled,
}) => {
	const [dragging, setDragging] = useState(false);

	const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		setDragging(true);
	}, []);

	const handleDragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
		e.preventDefault();
		setDragging(false);
	}, []);

	const handleDrop = useCallback(
		(e: React.DragEvent<HTMLDivElement>) => {
			e.preventDefault();
			e.stopPropagation();
			setDragging(false);
			if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
				onFilesSelected(e.dataTransfer.files);
				e.dataTransfer.clearData();
			}
		},
		[onFilesSelected],
	);

	const handleChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			if (event.target.files) {
				onFilesSelected(event.target.files);
			}
		},
		[onFilesSelected],
	);

	return (
		<LightTooltip
			title="Arraste e solte alguns arquivos aqui ou clique para selecionar arquivos"
			disableHoverListener={disabled}
		>
			<div
				className={`mr-3 cursor-pointer ${dragging ? 'border-blue-500 bg-blue-100' : 'border-gray-300'}`}
				onDragOver={handleDragOver}
				onDragLeave={handleDragLeave}
				onDrop={handleDrop}
			>
				<input
					type="file"
					multiple
					disabled={disabled}
					onChange={handleChange}
					className="hidden"
					id={`file-upload-${rowId}`}
				/>
				<label
					htmlFor={`file-upload-${rowId}`}
					className={cn(
						'flex h-full flex-col items-center justify-center text-center',
						disabled ? 'cursor-not-allowed' : 'cursor-pointer',
					)}
				>
					<UploadFileIcon sx={{ color: '#1E40AF' }} />
				</label>
			</div>
		</LightTooltip>
	);
};

export default FileUploadComponent;
